import LazyImage from './lazy-image';
import LazyImageBackground from './lazy-image-background';
import LazyImageLGBackground from './lazy-image-linear-gradient-background';

import {ImageUrlType} from './index.type';

export {LazyImageBackground, LazyImageLGBackground};
export type {ImageUrlType};
export default LazyImage;
